import BaseService from './BaseService';

class EmailNotificationSchedule extends BaseService{

  constructor() {
    super({ path: 'email-notification-schedule' });
  }

}

export default new EmailNotificationSchedule();
